import Typography from "@mui/material/Typography";
import { FiltroBandejaCompleto } from "../../../features/bandejaMutuos/models/filtroBandeja"
import { controlProps } from "../tablaServer"
import TableFilterComponent from "../tableFilterComponent"
import Grid from '@mui/material/Grid2';
import { TablaBasicFilter } from "../../../utils/tableBasicFilter";

interface TableHeaderProps {
    title?: string
    button?: JSX.Element
    control?: controlProps
    buttonExport?: JSX.Element
    searchFilter?: string | null
    setFiltros?: React.Dispatch<React.SetStateAction<TablaBasicFilter>>;
    hideSearchFilter?: boolean | undefined;
    component?: React.ReactNode;
}

const TableHeader: React.FC<TableHeaderProps> = ({ title, button, control, buttonExport, searchFilter, setFiltros, hideSearchFilter, component }) => {
    return (
        <>
            <Grid container sx={{ mb: 2, p: 2 }}>

                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    {control && !hideSearchFilter &&
                        <TableFilterComponent control={control} searchFilter={searchFilter} setFiltros={setFiltros} />}
                </Grid>

                <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                    {title && (
                        <Typography variant="subtitle1" fontWeight="bold">
                            {title}
                        </Typography>
                    )}
                </Grid>

                <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    {(buttonExport || button) && (
                        <Grid container spacing={1} sx={{ justifyContent: "flex-end", textAlign: "right" }}>
                            {buttonExport && (
                                <Grid>{buttonExport}</Grid>
                            )}
                            {button && (
                                <Grid>{button}</Grid>
                            )}
                            {component && (
                                <Grid>
                                    {component}
                                </Grid>
                            )}
                        </Grid>
                    )}
                </Grid>
            </Grid>

        </>
    )
}

export default TableHeader
